import { render, staticRenderFns } from "./ConsultaInventarioFilter.vue?vue&type=template&id=6c376aa7"
import script from "./ConsultaInventarioFilter.vue?vue&type=script&lang=js"
export * from "./ConsultaInventarioFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports